import { WalletStoreStatus } from './enum';
import { WalletState } from './interfaces/wallet-state';

export const singleCurrencyInitialState: WalletState = {
  entity: {
    balance: 0,
    exchangeRate: 1,
    depositAddress: '',
  },
  status: {
    [WalletStoreStatus.Loading]: [],
  },
};
